import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../Core/Components/CustomInput";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import RangePicker from "../../RangePicker";
import { updateRevenue } from "../../../../Redux/Slices/revenue.slice";
import { PAYMENT_RECEIVER_TYPE, PAYMENT_STATUS } from "../../data";
import getPaymentStatus from "../../getPaymentStatus";

const FarmerDetailHeader = ({
  search,
  setSearch,
  filters,
  setFilters,
  // setCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { selectedPayment } = useSelector((state) => state.revenue);

  const [focus, setFocus] = useState(false);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);

  const onDateRangeSelect = (e) => {
    // clear the date range and close the the date range input box
    if (filters.dateRangeStart !== "" && filters.dateRangeEnd !== "") {
      setFilters((prev) => ({
        ...prev,
        dateRangeStart: "",
        dateRangeEnd: "",
      }));

      setDateRangeOpen(false);
    }
    // set the start date and end date
    else {
      const [startMonth, endMonth] = e;

      setFilters((prev) => ({
        ...prev,
        dateRangeStart: startMonth,
        dateRangeEnd: endMonth,
      }));
    }
  };

  const getPaymentStatusTag = () => {
    // if amount exists only then show the tag
    if (
      (parseFloat(selectedPayment?.totalAmountDue) !== 0 &&
        selectedPayment.paymentStatus === PAYMENT_STATUS.PENDING) ||
      (parseFloat(selectedPayment?.totalAmountPaid) !== 0 &&
        selectedPayment.paymentStatus === PAYMENT_STATUS.COMPLETED)
    ) {
      const status =
        selectedPayment?.totalAmountDue === selectedPayment.totalAmountPaid
          ? PAYMENT_STATUS.COMPLETED
          : PAYMENT_STATUS.PENDING;

      return <div className="max-w-max">{getPaymentStatus(status)}</div>;
    }

    return null;
  };

  return (
    <div className="bg-background-white">
      <div className="px-6 py-2.5 flex items-center justify-between border-y-[0.5px] border-light-grey">
        <div className="flex items-center gap-x-3">
          <CustomInput
            intent="search"
            prefix={
              <img src="/assets/icons/search.svg" alt="" className="mr-2" />
            }
            value={search}
            focus={focus}
            border={focus ? "success" : "none"}
            placeholder={focus ? null : "Search Trip ID"}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            suffix={
              search.length > 0 ? (
                <CloseIcon
                  className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                  onClick={() => {
                    setFocus(false);
                    setSearch("");
                  }}
                />
              ) : null
            }
          />

          <div className="flex items-center">
            <RangePicker
              dateRangeOpen={dateRangeOpen}
              setDateRangeOpen={setDateRangeOpen}
              onChange={onDateRangeSelect}
              startDate={filters.dateRangeStart}
              endDate={filters.dateRangeEnd}
            />
          </div>
        </div>

        {+selectedPayment.entityType === PAYMENT_RECEIVER_TYPE.FARMER && (
          <div className="flex items-center gap-x-3">
            {getPaymentStatusTag()}

            <button
              type="button"
              className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
              onClick={() =>
                dispatch(
                  updateRevenue({
                    key: "transactionHistoryVisible",
                    value: true,
                  }),
                )
              }
            >
              <div className="flex item-center gap-x-2">
                <img
                  src="/assets/icons/receipt.svg"
                  className="w-4 h-4"
                  alt="transaction-history"
                />

                <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                  Transaction History
                </p>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FarmerDetailHeader;
